import {ElasticParser, ElasticSearchProperty} from '../factory.parsers';
import {buildQueryGreater, buildQueryLess, buildQueryRange, buildQueryTermEqual} from '../../query/elastic.queries';

export const numberExp = '((\\+|-)?\\d+(\\.\\d+)?([Ee][+-]?\\d+)?)';
export const numberRangeExp = `(${numberExp})\\s*\\.\\.\\s*(${numberExp})`;
export const numberGtExp = `>\\s*(${numberExp})`;
export const numberLtExp = `<\\s*(${numberExp})`;

export const numberRegExp = new RegExp(`^${numberExp}$`);
export const numberRangeRegExp = new RegExp(`^${numberRangeExp}$`);
export const numberGtRegExp = new RegExp(`^${numberGtExp}$`);
export const numberLtRegExp = new RegExp(`^${numberLtExp}$`);

export class NumberParser implements ElasticParser {
  parseValue(numbersString: string, elasticSearchProperty: ElasticSearchProperty): any {
    const {property} = elasticSearchProperty;

    const numbersQueries = numbersString?.split('|')
      .map(numberString => numberString.trim())
      .filter(numberString => !!numberString)
      .map(numberString => {
        const isNumberStringANumber = numberRegExp.test(numberString);
        const isNumberStringARangeNumber = numberRangeRegExp.test(numberString);
        const isNumberStringGtNumber = numberGtRegExp.test(numberString);
        const isNumberStringLtNumber = numberLtRegExp.test(numberString);

        if (isNumberStringANumber) {
          return buildQueryTermEqual(property, numberString);
        } else if (isNumberStringARangeNumber) {
          const match = numberRangeRegExp.exec(numberString);

          return buildQueryRange(property, +match[1], +match[6]);
        } else if (isNumberStringGtNumber) {
          const match = numberGtRegExp.exec(numberString);

          return buildQueryGreater(property, +match[1]);
        } else if (isNumberStringLtNumber) {
          const match = numberLtRegExp.exec(numberString);

          return buildQueryLess(property, +match[1]);
        } else {
          return undefined;
        }
      });

    const isNumbersQueriesDefined = numbersQueries?.filter(query => !!query).length > 0;

    if (isNumbersQueriesDefined) {
      return {bool: {should: numbersQueries}};
    } else {
      return undefined;
    }
  }
}
